import { Feature, NavAccessDeps } from '@app/constants'

export function hasFeature(feature: Feature) {
  return (dep: NavAccessDeps): boolean => dep.features.includes(feature)
}
